import { field, hidden, print } from "@/utils/models/decorator-field";
import { model } from "@/utils/models/decorator-model";
import { printHumanFloat } from "@/utils/pretty-print";
import SizeTableEntry from "./size-table-entry";

@model("ProductSizeStock")
export class ProductSizeStock {
	@field("number")
	@hidden()
	ProductID:number = 0;

	@field("number")
	@hidden()
	SizeTableEntryID:number = 0;

	@field("string")
	@hidden()
	ProductSku:string = "";

	@field("number")
	@print(printHumanFloat)
	Location1Qty:number = 0.0;
	@field("number")
	@print(printHumanFloat)
	Location2Qty:number = 0.0;
	@field("number")
	@print(printHumanFloat)
	Location3Qty:number = 0.0;
	@field("number")
	@print(printHumanFloat)
	Location4Qty:number = 0.0;
	@field("number")
	@print(printHumanFloat)
	Location5Qty:number = 0.0;
	@field("number")
	@print(printHumanFloat)
	Location6Qty:number = 0.0;
	@field("number")
	@print(printHumanFloat)
	Location7Qty:number = 0.0;
	@field("number")
	@print(printHumanFloat)
	Location8Qty:number = 0.0;
	@field("number")
	@print(printHumanFloat)
	Location9Qty:number = 0.0;

	@field("number")
	@print(printHumanFloat)
	TotalQty:number = 0.0;

	@field("has-one", "SizeTableEntry")
	SizeTableEntry:SizeTableEntry | null = null;

	public constructor(data?:any) {
		if (!data) return;
		this.ProductID = data.ProductID;
		this.SizeTableEntryID = data.SizeTableEntryID;
		this.ProductSku = data.ProductSku;
		this.Location1Qty = data.Location1Qty;
		this.Location2Qty = data.Location2Qty;
		this.Location3Qty = data.Location3Qty;
		this.Location4Qty = data.Location4Qty;
		this.Location5Qty = data.Location5Qty;
		this.Location6Qty = data.Location6Qty;
		this.Location7Qty = data.Location7Qty;
		this.Location8Qty = data.Location8Qty;
		this.Location9Qty = data.Location9Qty;
		this.TotalQty = data.TotalQty;
		this.SizeTableEntry = data.SizeTableEntry ? new SizeTableEntry(data.SizeTableEntry) : null;
	}

	public getStockAtLocation(locationId:number):number {
		if (locationId < 1 || locationId > 9) {
			throw new Error("StockLocationID out of range");
		}
		return (this as any)[`Location${locationId}Qty`];
	}

	public getTotalInStock():number {
		let total = 0;
		for (let i = 1; i <= 9; i++) {
			total += (this as any)[`Location${i}Qty`] || 0;
		}
		return total;
	}
}
